import { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { CUSTOMER_QUERY } from '../../queries';
import {
  SET_PAYMENT_METHOD,
  SET_LOADING_CUSTOMER,
  SET_ERROR_CUSTOMER,
} from '../../hooks/usePurchasePage';
import CreditCard from '../CreditCard';
import RadioInput from '../inputs/RadioInput';
import AddPaymentMethod from './AddPaymentMethod';
import SelectInput from '../inputs/SelectInput';
import { capitalize } from '../../utils';
import { isStripePaymentRequired } from '../../utils/featureFlags';

export default function SelectPaymentMethod({ state, dispatch }) {
  const { paymentMethod, paymentMethodType, orderDetails } = state;

  const { loading, error, data } = useQuery(CUSTOMER_QUERY, {
    skip: !isStripePaymentRequired(),
  });
  const customer = data?.customer;
  const paymentMethods = customer?.paymentMethods;

  if (!isStripePaymentRequired()) {
    return (
      <>
        {/*<h4>Payment</h4>*/}
        {/*<p className="text-gray-600 py-4">Order based payment HERE</p>*/}
      </>
    );
  }

  useEffect(() => {
    if (paymentMethods?.length > 0) {
      const defaultPaymentMethod = paymentMethods.find(
        ({ card }) => card?.isDefault
      );

      dispatch({
        type: SET_PAYMENT_METHOD,
        payload: {
          paymentMethod: defaultPaymentMethod || paymentMethods[0],
          paymentMethodType: 'saved',
        },
      });
    }
  }, [paymentMethods, dispatch]);

  useEffect(() => {
    dispatch({
      type: SET_LOADING_CUSTOMER,
      payload: loading,
    });
  }, [loading, dispatch]);

  useEffect(() => {
    dispatch({
      type: SET_ERROR_CUSTOMER,
      payload: error,
    });
  }, [error, dispatch]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('addPaymentMethod') === 'confirming') {
      dispatch({
        type: SET_PAYMENT_METHOD,
        payload: {
          paymentMethodType: 'saved',
        },
      });
    }
  }, [dispatch]);

  return (
    <>
      <h4>Payment</h4>
      {!error &&
        customer &&
        customer?.paymentMethods?.length > 0 &&
        paymentMethodType === 'saved' && (
          <CreditCard
            className="mr-6"
            last4={paymentMethod?.card?.last4}
            exp={`${paymentMethod?.card?.exp_month} / ${paymentMethod?.card?.exp_year}`}
            brand={paymentMethod?.card?.brand}
            active={true}
            isDefault={paymentMethod?.card?.isDefault}
          />
        )}
      {((error && error.message === 'stripe-customer-does-not-exist') ||
        customer?.paymentMethods?.length === 0 ||
        paymentMethodType === 'new') && (
        <div className="flex flex-col py-10">
          {error && error.message === 'stripe-customer-does-not-exist' && (
            <p>
              You haven't set up payments yet. Please add a payment method
              below.
            </p>
          )}
          <AddPaymentMethod
            className="pt-4"
            urlParamsToPersist={orderDetails}
          />
        </div>
      )}
      <div className="flex flex-col pt-10 pb-2 space-y-3">
        <div className="flex flex-row items-center">
          <button
            className="flex flex-row"
            type="button"
            onClick={() =>
              dispatch({
                type: SET_PAYMENT_METHOD,
                payload: {
                  paymentMethodType: 'saved',
                },
              })
            }
          >
            <RadioInput
              className="mr-2 cursor-pointer"
              checked={paymentMethodType === 'saved'}
              readOnly
            />{' '}
            Saved payment methods
          </button>
          <SelectInput
            className="ml-3"
            onChange={(value) =>
              dispatch({
                type: SET_PAYMENT_METHOD,
                payload: {
                  paymentMethod: paymentMethods.find(({ id }) => id === value),
                },
              })
            }
            value={paymentMethod?.id}
            placeholder="Select a card"
            options={customer?.paymentMethods.map(({ id, card }) => {
              const { brand, last4, isDefault } = card;
              return {
                name: `${capitalize(brand)} | ${last4}${
                  isDefault ? ' (default)' : ''
                }`,
                value: id,
              };
            })}
          />
        </div>
        <button
          className="flex flex-row"
          type="button"
          onClick={() =>
            dispatch({
              type: SET_PAYMENT_METHOD,
              payload: {
                paymentMethodType: 'new',
              },
            })
          }
        >
          <RadioInput
            className="mr-2 cursor-pointer"
            checked={paymentMethodType === 'new'}
            readOnly
          />{' '}
          New payment method
        </button>
      </div>
    </>
  );
}
